export default __webpack_public_path__ + "img/41006576ec2a4ebc5f94195b8c8aae61.png";